module.exports = __webpack_public_path__ + "static/media/DigiTaal_Thumbnail.4c5c142a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiTaal_Thumbnail.jpg
// module id = 814
// module chunks = 3